// Контент статей раздела «Какао-академия».
// Каждая статья описывается набором блоков, которые рендерит универсальный
// компонент ArticlePage.vue. Чтобы добавить новую статью, нужно завести
// здесь ещё один ключ-slug, положить картинки в app/assets/img/article/<folder>/
// и создать в Drupal ноду «Статьи» с тем же slug в поле field_slug — без
// ноды адрес статьи отдаёт 404.
//
// Типы блоков:
//   { type: 'image',        src }
//   { type: 'section',      tip?, summary?, heading, content }
//   { type: 'sectionImage',  tip?, side: 'left' | 'right', image, heading, content }
//   { type: 'infographics', heading, items: [{ icon, text }] }
//   { type: 'header',        title, text }
//   { type: 'sectionDouble', tip?, subsections: [{ heading, content }] }
//
// heading / content / tip могут содержать HTML (выводятся через v-html).
// related — ключ блока из data/articles.js, который показывается в подвале.
// Тексты <title> и meta description здесь не лежат: их задаёт редактор
// в метатегах ноды, приложение забирает их из /api/seo/data — см.
// app/data/seo.js.

export const articleContent = {
  history: {
    title: 'История шоколада',
    subtitle: 'Как напиток древних стал тем, что мы так любим сегодня?',
    folder: 'article1',
    related: 2,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>С чего началась история шоколада</li>
          <li>Почему майя считали какао особенным продуктом</li>
          <li>Как какао попало в Европу</li>
          <li>Кто придумал шоколад в привычном нам виде</li>
          <li>Как шоколад стал любимым лакомством миллионов</li>
        </ul>`,
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'section',
        tip: 'Я был частью ритуалов, а&nbsp;не&nbsp;десертом!',
        heading: 'Какао в культуре майя',
        content: `<p>Майя считали какао связующим звеном с&nbsp;божественным миром. Оно&nbsp;упоминается в&nbsp;мифологии и&nbsp;изображается в&nbsp;священных книгах, где&nbsp;боги держат плоды и&nbsp;зёрна какао в&nbsp;руках.</p>
          <p>Шоколадный напиток занимал важное место в&nbsp;ритуалах и праздниках — он&nbsp;был неотъемлемой частью свадебных церемоний, символизировал союз двух родов и&nbsp;сопровождал погребальные обряды знати: сосуды с&nbsp;напитком помещали в&nbsp;могилы, чтобы они сопровождали умершего в&nbsp;загробный мир.</p>`,
      },
      {
        type: 'section',
        heading: 'Какао как валюта',
        content: `<p>После упадка цивилизации майя на&nbsp;смену им пришли ацтеки. Покорённые ими народы поставляли какао в&nbsp;качестве дани, так как какао-деревья на&nbsp;землях ацтеков не&nbsp;росли. Со временем какао-бобы стали своеобразной валютой, с&nbsp;их&nbsp;помощью платили налоги и&nbsp;вели торговлю.</p>
          <p>Какао символизировало власть, силу и&nbsp;богатство, поэтому было доступно в&nbsp;основном воинам, жрецам и&nbsp;знати.</p>`,
      },
      { type: 'image', src: 'img2.webp' },
      {
        type: 'infographics',
        heading: 'Стоимость в&nbsp;какао-бобах в&nbsp;1545 году',
        items: [
          { icon: 'icon1.svg', text: 'Индейка <br/>100 какао-бобов' },
          { icon: 'icon2.svg', text: 'Авокадо <br/>3 какао-боба' },
        ],
      },
      {
        type: 'section',
        tip: 'На сладкое это&nbsp;совсем не&nbsp;было похоже...',
        heading: 'Первый шоколад',
        content: `<p>Ацтеки разработали рецепт напитка из&nbsp;какао-бобов. Они&nbsp;смешивали какао с&nbsp;водой, кукурузной мукой и&nbsp;перцем чили. Такой напиток назывался «шоколатль».</p>
          <p>Его&nbsp;вкус был&nbsp;далёк от&nbsp;современного шоколада&nbsp;— он&nbsp;был горьким и&nbsp;пряным, но&nbsp;именно он&nbsp;лёг в&nbsp;основу привычного нам&nbsp;продукта.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img5.webp',
        heading: 'Обработка какао',
        content: `<p>Уже&nbsp;тысячи лет&nbsp;назад какао-бобы проходили важные этапы обработки, которые используются и&nbsp;сегодня.</p>
          <p>После&nbsp;извлечения бобов из&nbsp;плодов начиналось естественное брожение: сладкая мякоть выделяла сок, и&nbsp;происходила ферментация, формирующая вкус.</p>
          <p>Затем бобы сушили, обжаривали и&nbsp;растирали до&nbsp;пасты. Иногда добавляли ароматические травы. Полученную массу разводили водой, процеживали и&nbsp;переливали из&nbsp;сосуда в&nbsp;сосуд, создавая пену&nbsp;— самую ценную часть напитка.</p>`,
      },
      {
        type: 'section',
        tip: 'Вот тут началась моя новая жизнь!',
        heading: 'Путь какао в&nbsp;Европу',
        content: `<p>Первым европейцем, попробовавшим какао-бобы, был Христофор Колумб, который в&nbsp;1502 году привез плоды в&nbsp;Испанию, но&nbsp;тогда их&nbsp;никто не&nbsp;заметил среди множества заморских даров.</p>
          <p>Через&nbsp;26&nbsp;лет&nbsp;какао снова попало в&nbsp;Европу вместе с&nbsp;рецептом шоколатля, который привезли испанские конкистадоры.</p>`,
      },
      {
        type: 'section',
        heading: 'Как&nbsp;шоколад стал сладким',
        content: `<p>Сначала напиток не&nbsp;понравился европейцам&nbsp;— он&nbsp;был слишком горьким и&nbsp;непривычным. Со&nbsp;временем в&nbsp;него начали добавлять сахар, и&nbsp;вкус полностью изменился.</p>
          <p>Позже появились новые рецепты&nbsp;— с&nbsp;корицей, мёдом и&nbsp;ванилью. Шоколад постепенно стал популярным во&nbsp;всей Европе.</p>`,
      },
      { type: 'image', src: 'img3.webp' },
      {
        type: 'section',
        heading: 'Шоколадная культура',
        content: `<p>С XVII века из экзотического напитка шоколад постепенно превращается в&nbsp;важную часть европейской культуры.</p>
          <p>Европейцы не&nbsp;только добавляют в&nbsp;него сахар, но&nbsp;и&nbsp;начинают готовить его с&nbsp;корицей, мёдом, ванилью.</p>`,
      },
      {
        type: 'section',
        heading: 'Индустриальная революция',
        content: `<p>В&nbsp;XIX веке произошёл прорыв в&nbsp;производстве шоколада.</p>
          <p class="_timestamp"><strong>1828</strong>Голландец Конрад Иоханнес ван Хаутен научился извлекать какао-масло из&nbsp;семян какао и&nbsp;получать какао-порошок.</p>
          <p class="_timestamp"><strong>1847</strong>В Англии создана первая твёрдая шоколадная плитка, состоящая из&nbsp;какао-массы, какао-масла и&nbsp;сахара.</p>
          <p class="_timestamp"><strong>1876</strong>Генри Нестле, основатель компании Nestlé, с&nbsp;1875 года начал поставлять Даниелю Петеру — другому бизнесмену из&nbsp;г.&nbsp;Веве — сухое молоко. Именно на&nbsp;его основе в&nbsp;1876 году Петер создал первый молочный шоколад.</p>
          <p class="_timestamp"><strong>1879</strong>Изобретена конш-машина для размалывания шоколадной массы, благодаря которой шоколад получил привычную нам нежную текстуру.</p>`,
      },
      { type: 'image', src: 'img4.webp' },
      {
        type: 'section',
        heading: 'Взлёт популярности шоколада',
        content: `<p>С&nbsp;конца XIX века шоколад стал массовым продуктом. Его&nbsp;производство и&nbsp;рецептура продолжали развиваться, появлялись новые формы и&nbsp;вкусы.</p>
          <p>Так, в&nbsp;1936 году компания Nestlé выпустила первую в&nbsp;мире белую шоколадку. В&nbsp;отличие от&nbsp;традиционного шоколада белый не&nbsp;содержит какао-массу — только какао-масло, молоко и&nbsp;сахар.</p>`,
      }
    ],
  },

  processing: {
    title: 'ПЕРЕРАБОТКА КАКАО-БОБОВ',
    subtitle: 'Как какао-бобы превращаются в ароматный шоколад',
    folder: 'article2',
    related: 2,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>Почему какао собирают вручную</li>
          <li>Что происходит с бобами после сбора</li>
          <li>Как появляются вкус и аромат шоколада</li>
          <li>Из чего делают какао-порошок и какао-масло</li>
          <li>Какие этапы проходит шоколадная масса</li>
        </ul>`,
      },
      {
        type: 'section',
        heading: 'Сбор какао-бобов',
        content: `<p>Какао-бобы собирают примерно через полгода после начала сезона дождей. Обычно первые плоды — самые крупные, но их количество и скорость созревания зависят от климата и региона выращивания.</p>
          <p>Какао-деревья очень хрупкие, поэтому плоды до сих пор собирают вручную. Автоматизировать этот процесс почти невозможно — сбор требует аккуратности и большого опыта.</p>
          <p>После сбора бобы проходят ферментацию, сушку и сортировку. Именно с этого начинается путь будущего шоколада.</p>`,
      },
      {
        type: 'sectionImage',
        tip: 'Обязательная spa-процедура очистки',
        side: 'left',
        image: 'img1.webp',
        heading: 'Этап 1. Очистка какао-бобов',
        content: `<p>После доставки на производство какао-бобы очищают от всего лишнего: пыли, ниток, мелких камней и других посторонних частиц.</p>
          <p>Это важно для того, чтобы шоколад получился чистым и безопасным.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img2.webp',
        heading: 'Этап 2. Обжарка и&nbsp;пробуждение аромата',
        content: `<p>Затем какао-бобы отправляются на обжарку.</p>
          <p>Высокая температура:</p>
          <ul>
            <li>раскрывает аромат,</li>
            <li>уменьшает влажность,</li>
            <li>убирает лишнюю кислотность,</li>
            <li>уничтожает микроорганизмы.</li>
          </ul>
          <p>Именно во время обжарки начинает появляться тот самый насыщенный шоколадный запах.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img3.webp',
        heading: 'Этап 3. Дробление и отделение какао-веллы',
        content: `<p>После обжарки бобы становятся хрупкими. Их дробят на мелкие кусочки — какао-крупку.</p>
          <p>Одновременно отделяется оболочка — какао-велла. Её тоже используют в производстве, например, при создании некоторых видов конфет.</p>`,
      },
      {
        type: 'sectionImage',
        tip: 'На этом этапе я становлюсь похож на жидкий шоколад!',
        side: 'right',
        image: 'img4.webp',
        heading: 'Этап 4. Получение какао тёртого',
        content: `<p>Какао-крупку измельчают до состояния густой шоколадной массы — какао тёртого.</p>
          <p>По консистенции она напоминает густую сметану.</p>
          <p>Чем мельче измельчены частицы, тем более насыщенным и мягким получается вкус будущего шоколада.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img5.webp',
        heading: 'Этап 5. Получение какао-масла и какао-порошка',
        content: `<p>Какао тёртое разделяют на два основных продукта:</p>
          <p><strong>Какао-масло</strong></p>
          <p>Основа шоколада. Это натуральный жир какао-бобов, содержащий антиоксиданты.</p>
          <p><strong>Какао-жмых</strong></p>
          <p>Твёрдый остаток после отделения масла. Именно из него делают какао-порошок.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img6.webp',
        heading: 'Этап 6. Создание шоколадной массы',
        content: `<p>Теперь начинается создание настоящего шоколада.</p>
          <p>В массу добавляют:</p>
          <ul>
            <li>какао тёртое,</li>
            <li>сахар,</li>
            <li>какао-масло.</li>
          </ul>
          <p>Все ингредиенты тщательно перемешивают, чтобы вкус и текстура стали полностью однородными.</p>`,
      },
      {
        type: 'sectionImage',
        tip: 'Чем мельче частицы — тем нежнее шоколад!',
        side: 'left',
        image: 'img7.webp',
        heading: 'Этап 7. Вальцевание массы',
        content: `<p>Шоколадную массу пропускают через специальные мельницы.</p>
          <p>Этот этап делает шоколад:</p>
          <ul>
            <li>более нежным,</li>
            <li>однородным,</li>
            <li>мягким по текстуре.</li>
          </ul>
          <p>После обработки масса становится буквально шелковистой.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img8.webp',
        heading: 'Этап 8. Конширование шоколада',
        content: `<p>Один из самых важных этапов — конширование.</p>
          <p>Шоколадную массу долго перемешивают при высокой температуре и постоянном контакте с воздухом. Иногда процесс занимает много часов.</p>
          <p>Во время конширования:</p>
          <ul>
            <li>уходят лишние запахи,</li>
            <li>уменьшается кислотность,</li>
            <li>испаряется влага,</li>
            <li>вкус становится глубже и мягче.</li>
          </ul>
          <p>Именно здесь шоколад приобретает свою бархатистую текстуру и насыщенный аромат.</p>`,
      },
      {
        type: 'sectionImage',
        tip: 'Финальный штрих 👌',
        side: 'left',
        image: 'img9.webp',
        heading: 'Этап 9. Финальная настройка вкуса',
        content: `<p>Чтобы шоколад стал пластичным и текучим, в&nbsp;массу добавляют больше какао-масла или специальные растительные компоненты.</p>
          <p>На этом этапе также могут добавляться:</p>
          <ul>
            <li>ваниль,</li>
            <li>специи,</li>
            <li>ореховые ноты,</li>
            <li>ароматизаторы,</li>
            <li>иногда даже алкоголь.</li>
          </ul>
          <p>Именно здесь создаются разные виды шоколада и уникальные рецептуры.</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Путь от какао-боба до шоколадной плитки — это сложный и очень точный процесс.</p>
          <p>Сначала бобы собирают вручную, затем очищают, обжаривают, измельчают и превращают в шоколадную массу. После долгой обработки шоколад приобретает свой знакомый вкус, аромат и текстуру.</p>
          <p>Каждая плитка шоколада — результат множества этапов и большой работы людей и технологий.</p>`,
      },
    ],
  },

  contents: {
    title: 'СОСТАВ ШОКОЛАДА',
    subtitle: 'Из чего на самом деле состоит шоколад?',
    folder: 'article3',
    related: 2,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>Какие ингредиенты есть в шоколаде</li>
          <li>Зачем нужно какао-масло</li>
          <li>Почему молочный шоколад такой нежный</li>
          <li>Какие ингредиенты самые дорогие</li>
          <li>Для чего добавляют лецитин и ваниль</li>
        </ul>`,
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'section',
        heading: 'Шоколад — больше, чем просто сладость',
        content: `<p>Шоколад давно стал частью нашей жизни. Это не только десерт, но и эмоции, привычки, уютные моменты и маленькие радости каждый день. Но из чего он состоит?</p>
          <p>Основа шоколада — это несколько ключевых ингредиентов, каждый из которых отвечает за вкус, текстуру и аромат.</p>`,
      },
      {
        type: 'section',
        heading: 'Основные ингредиенты',
        content: `<p>Шоколад состоит из четырёх основных компонентов: какао-продуктов, молочных компонентов, сахара и добавок. Каждый из них влияет на вкус, аромат и текстуру шоколада.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img2.webp',
        heading: 'Какао тёртое',
        content: `<p>Какао тёртое — это густая насыщенная масса, которую получают после дробления и измельчения обжаренных какао-бобов. В ней содержатся какао-масло и твёрдые частицы какао-бобов.</p>
          <p>Именно какао тёртое формирует основу шоколада и придаёт ему характерный насыщенный вкус.</p>
          <p><strong>Что делает:</strong></p>
          <ul>
            <li>придаёт шоколаду насыщенный вкус;</li>
            <li>составляет основу любого шоколада, кроме белого.</li>
          </ul>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img3.webp',
        heading: 'Какао-масло',
        content: `<p>Какао-масло — натуральный жир, который получают из какао тёртого путём прессования.</p>
          <p>Этот ингредиент отвечает за текстуру шоколада, его блеск и правильное таяние.</p>
          <p><strong>Что делает:</strong></p>
          <ul>
            <li>придаёт шоколаду структуру и гладкую поверхность;</li>
            <li>помогает шоколаду оставаться твёрдым и ломаться с характерным хрустом;</li>
            <li>влияет на ощущение таяния во рту.</li>
          </ul>`,
      },
      {
        type: 'section',
        heading: 'Сахар',
        content: `<p>Сахар нужен не только для сладости. Он помогает сбалансировать вкус какао и объединяет ингредиенты между собой.</p>
          <p>При этом важно соблюдать правильные пропорции: если сахара слишком много, шоколад может стать слишком мягким и приторным.</p>
          <p><strong>Что делает:</strong></p>
          <ul>
            <li>балансирует горечь какао;</li>
            <li>влияет на текстуру шоколада;</li>
            <li>помогает продлить срок хранения.</li>
          </ul>`,
      },
      {
        type: 'section',
        heading: 'Молочные компоненты',
        content: `<p>В производстве молочного шоколада используют сухое молоко, молочные жиры, сыворотку и лактозу.</p>
          <p>Именно они делают шоколад более мягким, сливочным и нежным по вкусу.</p>
          <p><strong>Что делают:</strong></p>
          <ul>
            <li>придают шоколаду сливочный вкус;</li>
            <li>создают мягкую текстуру;</li>
            <li>добавляют приятный сладковатый аромат.</li>
          </ul>
          <p>Цельное молоко считается более дорогим ингредиентом, но именно оно делает вкус шоколада более глубоким и насыщенным.</p>`,
      },
      {
        type: 'section',
        heading: 'Самые дорогие ингредиенты',
        content: `<p>Несмотря на большое количество компонентов, шоколад остаётся доступным лакомством.</p>
          <p>При этом самыми ценными и дорогими ингредиентами считаются какао-масса и какао-масло. Именно они отвечают за вкус, аромат и текстуру шоколада.</p>
          <p>Высокая стоимость этих компонентов ещё раз показывает, насколько ценны какао-бобы и как много этапов обработки они проходят перед тем, как превратиться в шоколад.</p>`,
      },
      { type: 'image', src: 'img4.webp' },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img5.webp',
        heading: 'Добавки',
        content: `<p>Помимо основных ингредиентов, в шоколаде используются дополнительные компоненты — добавки.</p>
          <p>Они помогают улучшить вкус, аромат и текстуру шоколада, а также делают процесс производства более удобным и стабильным.</p>`,
      },
      {
        type: 'section',
        heading: 'Лецитин',
        content: `<p>Лецитин — натуральный эмульгатор, который получают из сои, подсолнечника или рапса.</p>
          <p>Он помогает соединять вещества, которые обычно не смешиваются между собой — например, жир и воду.</p>
          <p>Благодаря лецитину шоколад становится более пластичным и менее густым, а значит, его проще обрабатывать и придавать ему нужную форму.</p>
          <p><strong>Что делает:</strong></p>
          <ul>
            <li>улучшает текстуру шоколада;</li>
            <li>делает массу более пластичной;</li>
            <li>помогает равномерно смешивать ингредиенты.</li>
          </ul>`,
      },
      {
        type: 'section',
        heading: 'Ваниль',
        content: `<p>Натуральная ваниль — одна из самых дорогих пряностей в мире.</p>
          <p>Её добавляют в шоколад, чтобы придать ему лёгкий и узнаваемый аромат.</p>
          <p>Иногда вместо натуральной ванили используют ванилин — её синтетический аналог, который помогает сохранить знакомый вкус и аромат шоколада.</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Шоколад — это сложное сочетание ингредиентов, где каждый компонент играет свою роль.</p>
          <p>Какао тёртое отвечает за насыщенный вкус, какао-масло — за текстуру и блеск, молочные компоненты делают шоколад более нежным, а сахар и добавки помогают добиться правильного вкуса, аромата и формы.</p>
          <p>Именно баланс всех ингредиентов превращает какао-бобы в тот самый шоколад, который мы знаем и любим.</p>`,
      },
    ],
  },

  types: {
    title: 'ТИПЫ ШОКОЛАДА И&nbsp;НАЧИНОК',
    subtitle: 'Шоколад проходит долгий путь прежде, чем оказаться на полке магазина. После приготовления шоколадной массы начинается не менее важный этап — формирование, охлаждение и упаковка будущей плитки.',
    folder: 'article4',
    related: 2,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        tip: 'Пора узнать шоколад поближе',
        content: `<ul>
          <li>Как шоколад становится гладким и блестящим</li>
          <li>Почему шоколад может «седеть»</li>
          <li>Как правильно хранить шоколад</li>
          <li>Чем отличаются разные виды шоколада</li>
          <li>Какие начинки добавляют в шоколад</li>
          <li>Почему воздушный шоколад — воздушный</li>
        </ul>`,
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'header',
        title: 'Пять стадий принятия… шоколада',
        text: 'Шоколаду тоже нужно пройти несколько важных стадий — только не расставания, а приготовления.',
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img2.webp',
        tip: 'Тут я учусь красиво хрустеть 😎',
        heading: '1. Темперирование',
        content: `<p>Чтобы шоколад получился гладким, блестящим и хрустящим, шоколадную массу специально охлаждают и нагревают по определённой схеме.</p>
          <p>Сначала массу охлаждают примерно до 26 °C, а затем снова нагревают до 32 °C. Этот процесс называется темперированием.</p>
          <p>Именно благодаря ему шоколад приобретает правильную структуру, красивый блеск и характерный хруст при разломе.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img3.webp',
        heading: '2. Отливка',
        content: `<p>После темперирования жидкий шоколад разливают в специальные формы — металлические или пластиковые.</p>
          <p>Именно поверхность формы помогает шоколаду стать гладким и блестящим.</p>
          <p>На этом этапе появляются знакомые плитки, батончики и конфеты.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img4.webp',
        tip: 'Пузырькам тут не&nbsp;место 👀',
        heading: '3. Удаление пузырьков',
        content: `<p>Чтобы внутри шоколада не осталось воздуха, формы отправляют на вибротранспортёр.</p>
          <p>Во время вибрации шоколадная масса равномерно распределяется по форме, а пузырьки воздуха полностью исчезают.</p>
          <p>Благодаря этому шоколад получается плотным и однородным.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img5.webp',
        heading: '4. Охлаждение',
        content: `<p>После&nbsp;заливки формы отправляются в&nbsp;охлаждающий туннель.</p>
          <p>Это&nbsp;специальная камера с&nbsp;точно контролируемой температурой, где&nbsp;шоколад постепенно застывает во&nbsp;время движения по&nbsp;конвейеру.</p>
          <p>Во&nbsp;время охлаждения шоколад:</p>
          <ul>
            <li>приобретает стабильную структуру;</li>
            <li>становится блестящим;</li>
            <li>легко выходит из&nbsp;формы;</li>
            <li>сохраняет аккуратный внешний&nbsp;вид.</li>
          </ul>
          <p>Для&nbsp;каждого типа шоколада используется своя температура охлаждения.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img6.webp',
        tip: 'Теперь я готов к&nbsp;путешествию',
        heading: '5. Упаковка',
        content: `<p>Готовый шоколад заворачивают в&nbsp;упаковку: фольгу, ламинированную бумагу, картон, пергамент или крафт-бумагу.</p>
          <p>Упаковка помогает сохранить:</p>
          <ul>
            <li>вкус и аромат,</li>
            <li>свежесть,</li>
            <li>текстуру шоколада.</li>
          </ul>
          <p>Дополнительно используют SRP-упаковку — специальные коробки, которые одновременно служат транспортной упаковкой и готовой выкладкой для магазина.</p>`,
      },
      {
        type: 'section',
        heading: 'Шоколадная «седина»',
        content: `<p>Белые пятна на шоколаде называют «поседением».</p>
          <p>Такое происходит из-за влаги, перепадов температуры или изменений структуры какао-масла.</p>
          <p>Это естественный процесс, который не влияет на вкус и безопасность продукта.</p>`,
      },
      {
        type: 'section',
        heading: 'Как правильно хранить шоколад',
        content: `<p>Чтобы шоколад сохранял вкус и текстуру, его лучше хранить:</p>
          <ul>
            <li>при температуре 15–21 °C;</li>
            <li>при влажности не более 75%.</li>
          </ul>
          <p>Лучше избегать жары, холодильника и резких перепадов температуры.</p>`,
      },
      {
        type: 'header',
        title: 'Фабрика полного цикла и виды шоколада',
        text: 'На фабриках полного цикла шоколад проходит все этапы производства — от&nbsp;обработки какао-бобов до упаковки готовой продукции.',
      },
      { type: 'image', src: 'img7.webp' },
      {
        type: 'sectionDouble',
        tip: 'Молочный — самый уютный вкус',
        subsections: [
          {
            heading: 'Молочный шоколад',
            content: `<p>Один из&nbsp;самых популярных видов шоколада.</p>
              <p>Молочным его&nbsp;делают молочные ингредиенты, а&nbsp;содержание какао в&nbsp;составе обычно составляет не&nbsp;менее 25%.</p>
              <p><strong>Молочный шоколад:</strong></p>
              <ul>
                <li>мягкий,</li>
                <li>сладкий,</li>
                <li>сливочный,</li>
                <li>более калорийный из-за&nbsp;высокого содержания сахара.</li>
              </ul>`,
          },
          {
            heading: 'Тёмный шоколад',
            content: `<p>Чем&nbsp;выше содержание какао, тем&nbsp;темнее и&nbsp;насыщеннее вкус шоколада.</p>
              <p><strong>В&nbsp;тёмном шоколаде:</strong></p>
              <ul>
                <li>меньше сахара;</li>
                <li>больше какао-продуктов;</li>
                <li>не&nbsp;менее 55% какао.</li>
              </ul>
              <p>Именно поэтому его&nbsp;вкус более яркий и&nbsp;горьковатый.</p>
              <p>Тёмный шоколад считается самым насыщенным по&nbsp;вкусу и&nbsp;содержит важные микроэлементы&nbsp;— кальций, железо и&nbsp;магний.</p>`,
          },
        ],
      },
      {
        type: 'sectionDouble',
        subsections: [
          {
            heading: 'Белый шоколад',
            content: `<p>Белый шоколад отличается от&nbsp;остальных тем, что&nbsp;в&nbsp;нём нет&nbsp;какао-порошка и&nbsp;твёрдых частиц какао-бобов.</p>
              <p><strong>Его&nbsp;готовят из:</strong></p>
              <ul>
                <li>какао-масла,</li>
                <li>сахара,</li>
                <li>молочных компонентов.</li>
              </ul>
              <p>Именно поэтому он&nbsp;остаётся светлым и&nbsp;имеет мягкий сливочный вкус.</p>`,
          },
          {
            heading: 'Рубиновый шоколад',
            content: `<p>В&nbsp;некоторых регионах Южной Америки выращивают особые рубиновые какао-бобы.</p>
              <p>Из&nbsp;них&nbsp;производят необычный шоколад с&nbsp;естественным розово‑красным оттенком и&nbsp;фруктовым вкусом.</p>
              <p>Главная особенность рубинового шоколада&nbsp;— его&nbsp;цвет и&nbsp;вкус появляются естественным образом, без&nbsp;красителей и&nbsp;ароматизаторов.</p>`,
          },
        ],
      },
      {
        type: 'section',
        heading: 'Начинка в шоколаде',
        content: `<p>Начинок у шоколада огромное количество.</p>
          <p><strong>В шоколад добавляют:</strong></p>
          <ul>
            <li>карамель,</li>
            <li>орехи,</li>
            <li>кокос,</li>
            <li>нугу,</li>
            <li>мармелад,</li>
            <li>кусочки фруктов,</li>
            <li>печенье и многое другое</li>
          </ul>
          <p>Именно начинка помогает создавать новые вкусы и делает шоколад ещё разнообразнее.</p>`,
      },
      {
        type: 'section',
        tip: 'Я таю быстрее остальных',
        heading: 'Почему воздушный шоколад — воздушный?',
        content: `<p>Пористый шоколад называют воздушным из-за его лёгкой структуры.</p>
          <p>Во время приготовления в шоколадную массу добавляют азот, благодаря которому внутри появляются маленькие пузырьки воздуха.</p>
          <p><strong>Такой шоколад:</strong></p>
          <ul>
            <li>легче по текстуре;</li>
            <li>быстрее тает;</li>
            <li>кажется менее плотным.</li>
          </ul>
          <p>Но из-за этого его легко съесть слишком много</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Шоколад бывает очень разным: молочным, тёмным, белым, рубиновым, пористым или с начинками.</p>
          <p>Каждый вид отличается составом, текстурой и вкусом, а производство шоколада требует точного соблюдения температуры, времени и технологий.</p>
          <p>Теперь ты знаешь, как шоколад приобретает форму, почему он может «седеть» и чем отличаются разные виды любимого десерта.</p>`,
      },
    ],
  },

  history_nestle: {
    title: 'История шоколада Nestlé',
    subtitle: 'XIX век и индустриальная революция изменили всё: шоколад перестал быть только напитком и стал твёрдым продуктом массового производства. Именно тогда появились две швейцарские компании — начало истории Nestlé.',
    folder: 'article5',
    related: 1,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>Как появился шоколад</li>
          <li>Как какао-бобы превращаются в шоколад</li>
          <li>Какие бывают виды шоколада</li>
          <li>Чем отличается молочный, тёмный и белый шоколад</li>
        </ul>`,
      },
      {
        type: 'header',
        title: 'Первые годы',
        text: 'Тысячи лет шоколад был только напитком. Но XIX век и индустриальная революция всё изменили: благодаря новым машинам компании начали выпускать твёрдый шоколад в промышленных масштабах. На волне прогресса появились две швейцарские компании — начало истории Nestlé.',
      },
      {
        type: 'section',
        heading: '1866 — рождение сгущёнки',
        content: `<p>Братья Чарльз и Джордж Пейдж привезли из Америки технологию производства сгущённого молока и основали «Англо-швейцарскую компанию» — первую подобную фабрику в Европе.</p>`,
      },
      {
        type: 'section',
        tip: 'Изобретение Нестле спасло жизнь малышу Ваннеру',
        heading: '1867 — детское питание Анри Нестле',
        content: `<p><strong>Как накормить ребёнка, если нет грудного молока?</strong></p>
          <p>В то время детская смертность была высокой — многие дети не могли питаться грудным молоком, а свежее молоко было доступно далеко не всегда. Нестле смешал свежее молоко с сахаром, выпарил до сиропа и добавил измельчённые сухари из пшеничной муки. Всё нужно было делать за один день, чтобы сохранить свежесть. Продукт получил название farine lactée — «мука с молоком».</p>`
      },
      {
        type: 'section',
        heading: '1868 — логотип с гнездом',
        content: `<p>Логотип с мамой-птицей, кормящей птенцов, появился в 1868 году — он основан на гербе семьи. На одном из немецких диалектов Nestlé означает «гнездо».</p>`
      },
      {
        type: 'section',
        heading: '1875 — первый молочный шоколад',
        content: `<p><strong>Главная задача: добавить молоко в шоколад так, чтобы вода в нём не портила смесь.</strong></p>
          <p>Кондитер Даниель Петер, сосед Нестле, бился над этой задачей несколько лет. Решение пришло из соседней лаборатории: сгущённое молоко Нестле убирало лишнюю воду. В 1875 году Петер создал «Gala Peter» — первый в мире молочный шоколад.</p>
          <p>К тому же году Анри Нестле отошёл от дел, продав фабрику в Веве трём местным бизнесменам.</p>`
      },
      {
        type: 'header',
        title: 'От конкурентов к союзникам',
        text: 'После успеха с молочным шоколадом и детским питанием два главных игрока — Nestlé и «Англо-швейцарская компания» — стали прямыми конкурентами. Но со временем производители поняли: для роста нужно объединяться.',
      },
      {
        type: 'section',
        heading: '1877 — начало конкуренции',
        content: `<p>«Англо-швейцарская компания» запустила собственное детское питание. Nestlé ответила производством сгущённого молока. Началось почти тридцатилетнее противостояние.</p>`
      },
      {
        type: 'section',
        heading: '1904 — первый союз: Peter + Kohler',
        content: `<p>Gala Peter объединилась с Kohler — компанией из Лозанны, известной шоколадом с фундуком. Nestlé получила право на экспорт их совместной продукции по всему миру.</p>`
      },
      {
        type: 'section',
        heading: '1905 — Nestlé и Англо-швейцарская объединяются',
        content: `<p>Спустя почти 30 лет конкуренции две компании объединились, образовав группу, которую мы знаем сегодня как Nestlé.</p>`
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'section',
        heading: '1911 — присоединяется Cailler',
        content: `<p>К Peter & Kohler присоединилась Cailler — компания Франсуа Луи Кайе. Это старейший из ныне действующих брендов швейцарского шоколада.</p>`
      },
      {
        type: 'section',
        tip: 'Четыре бренда стали одной шоколадной империей.',
        heading: '1929 — крупнейшее слияние',
        content: `<p>Nestlé объединилась с «Peter, Cailler, Kohler Chocolats Suisses S.A.», создав самую крупную шоколадную компанию Швейцарии: 20 фабрик и около трёх тысяч сотрудников.</p>`
      },
      {
        type: 'header',
        title: 'Эпоха изобретений'
      },
      {
        type: 'section',
        heading: '1936 — белый шоколад: счастливая случайность',
        content: `<p><strong>Nestlé не планировала изобретать белый шоколад.</strong></p>
          <p>Компания работала над витаминной смесью Nestrovit на основе сгущённого молока. В попытках получить более твёрдую структуру смесь смешали с какао-маслом — и получили совершенно новый продукт. Плитка вышла под названиями Milkybar (в Англии) и Galak (в остальной Европе). С 2007 года в производстве Milkybar не используют искусственные ингредиенты.</p>`
      },
      { type: 'image', src: 'img2.jpg' },
      {
        type: 'section',
        heading: '1937 — Rayon: мёд и пузырьки',
        content: `<p>Год спустя появился бренд Rayon — шоколад с медовой начинкой и воздушными пузырьками. Первый пористый шоколад Nestlé.</p>`
      },
      {
        type: 'section',
        tip: 'Просто добавь воду. Революция в кружке.',
        heading: '1938 — рождение Nescafé',
        content: `<p>Nestlé запустила продажи растворимого кофе Nescafé: натуральный аромат кофе при простоте приготовления. Название сложилось из первых трёх букв Nestlé и слова café.</p>`
      },
      {
        type: 'header',
        title: 'Мировая экспансия'
      },
      {
        type: 'section',
        heading: '1988 — KitKat, Smarties, After Eight',
        content: `<p>Приобретение британской Rowntree Mackintosh принесло Nestlé три культовых бренда: KitKat, Smarties и After Eight. Это сделало компанию одним из мировых лидеров шоколадного рынка.</p>`
      },
      {
        type: 'section',
        heading: '1990-е — локальные бренды по всему миру',
        content: `<p>Nestlé приобрела бренды с местной идентичностью: Orion в Чехии, Boci в Венгрии, «Россия — щедрая душа» в России, Garoto в Бразилии. Каждый бренд сохранил связь с родной страной.</p>`
      },
      {
        type: 'section',
        heading: '2019 — шоколад только из плодов какао',
        content: `<p>Nestlé представила первый тёмный шоколад на 100% из плодов какао: без добавленного сахара — только бобы и натуральная мякоть плода.</p>`
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Шоколад прошёл большой путь&nbsp;— от&nbsp;древнего напитка майя до&nbsp;любимого десерта миллионов людей.</p>
          <p>Ты&nbsp;узнал, как&nbsp;какао-бобы превращаются в&nbsp;шоколад, какие этапы проходит производство и&nbsp;чем&nbsp;отличаются разные виды шоколада.</p>
          <p>Теперь ты&nbsp;знаешь о&nbsp;шоколаде гораздо больше&nbsp;— почти как&nbsp;настоящий шоколатье.</p>`
      },
    ],
  },

  cultivation: {
    title: 'Выращивание какао-бобов',
    subtitle: 'В этой статье разберёмся, какими бывают какао-бобы, как растут какао-деревья и почему ферментация так важна для вкуса шоколада.',
    folder: 'article6',
    related: 1,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>Где появились какао-деревья</li>
          <li>Чем отличаются сорта какао</li>
          <li>Как растут и плодоносят какао-деревья </li>
          <li>Как собирают и обрабатывают какао-бобы </li>
          <li>Почему ферментация влияет на вкус шоколада</li>
        </ul>`,
      },
      {
        type: 'header',
        title: 'Откуда берётся какао',
        text: 'Какао-деревья появились тысячи лет назад в тропических лесах Южной  Америки. Именно с них начинается история всех какао-бобов и шоколада.',
      },
      {
        type: 'section',
        tip: 'Вот она – точка Х где начинается история шоколада',
        heading: 'Те самые деревья',
        content: `<p>Сегодня род Theobroma включает более 22 видов, а самый распространённый из них — Theobroma cacao.</p>
          <p>Именно этот вид стал основой современного шоколада.</p>`,
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'section',
        heading: 'Как какао распространилось по миру',
        content: `<p>Со временем какао-деревья распространились по Центральной и Южной Америке, а позже появились плантации в Африке и Азии.</p>
          <p>Сегодня какао выращивают в странах с жарким и влажным тропическим климатом.</p>`,
      },
      {
        type: 'section',
        heading: 'Какие бывают какао-бобы',
        content: `<p>Исторически какао делится на несколько групп в зависимости от происхождения, вкуса и особенностей выращивания.</p>
          <p>Именно сорт какао во многом определяет будущий вкус шоколада.</p>`,
      },
      { type: 'image', src: 'img2.jpg' },
      {
        type: 'section',
        heading: 'Forastero (Форастеро)',
        content: `<p>Лидер рынка, который обладает сильным, насыщенным и более горьким вкусом по сравнению с другими сортами.</p>
          <p>Из особенностей можно выделить высокую выносливость, устойчивость к болезням и урожайность.</p>
          <p>Выращивают Форастеро на плантациях Западной Африки, Бразилии и Юго-Восточной Азии.</p>`,
      },
      {
        type: 'section',
        tip: 'У каждого сорта свой характер вкуса',
        heading: 'Criollo (Криолло)',
        content: `<p>Самый ценный, редкий и дорогой сорт.</p>
          <p>Сегодня в чистом виде почти не встречается — он очень нежный, неустойчивый к вредителям и даёт мало урожая.</p>
          <p>Какао-бобы Криолло имеют травяные и фруктовые ноты во вкусе.</p>`,
      },
      {
        type: 'section',
        heading: 'Trinitario (Тринитарио)',
        content: `<p>Сорт-гибрид, полученный в результате скрещения Криолло и Форастеро.</p>
          <p>В российской шоколадной традиции этот сорт часто называют «Тринидад» — в честь острова, откуда он распространился по миру.</p>
          <p>Для Тринитарио характерны ноты сухофруктов и плоды разных цветов.</p>`,
      },
      {
        type: 'section',
        heading: 'Nacional (Насиональ)',
        content: `<p>Редкий и ценный сорт, известный ярким цветочным ароматом Arriba.</p>
          <p>Выращивается в Эквадоре и обладает фруктовыми нотами во вкусе.</p>`,
      },
      {
        type: 'section',
        heading: 'Ароматные и ординарные сорта',
        content: `<p>Криолло и Тринитарио относят к ароматным сортам, а Форастеро — к ординарным.</p>
          <p>Ароматные бобы составляют не более 10% мирового объёма какао.</p>
          <p>Селекция какао продолжается и сегодня — появляются новые миксы сортов.</p>`,
      },
      {
        type: 'header',
        title: 'Жизнь какао-дерева',
        text: 'Какао-деревья очень требовательны к климату. Для хорошего роста им нужны жара, влажность и защита от прямого солнца.',
      },
      {
        type: 'section',
        heading: 'Там, где влажно и душно',
        content: `<p>Для хорошего роста среднегодовая температура должна быть около +30–32 °C.</p>
          <p>Минимальная температура не должна опускаться ниже +18–21 °C, а влажность воздуха — ниже 70%.</p>
          <p>Какао-деревья любят дождь и плохо переносят засуху.</p>`,
      },
      { type: 'image', src: 'img3.webp' },
      {
        type: 'section',
        heading: 'Бананы и кокосы — рай для какао',
        content: `<p>Рядом с какао-деревьями часто высаживают банановые и кокосовые пальмы.</p>
          <p>Они создают тень, удерживают влагу в почве и защищают деревья от перепадов микроклимата.</p>`,
      },
      {
        type: 'section',
        tip: 'Какао-деревья очень любят тропический климат.',
        heading: 'Как выглядит дерево',
        content: `<p>Какао-дерево имеет тёмную кору и светло-зелёные глянцевые листья.</p>
          <p>Оно цветёт круглый год, поэтому на одном дереве одновременно можно увидеть и цветы, и плоды.</p>
          <p>Плоды напоминают небольшую дыню и меняют цвет по мере созревания.</p>`,
      },
      {
        type: 'section',
        heading: 'Сколько плодов даёт дерево',
        content: `<p>Высота дерева может достигать 10–15 метров, но на плантациях его обрезают для удобства сбора.</p>
          <p>Одно дерево приносит примерно 20–30 плодов в год.</p>
          <p>Каждый плод содержит от 20 до 40 семян.</p>`,
      },
      {
        type: 'section',
        heading: 'Медленный рост',
        content: `<p>Первые плоды появляются только через 4–5 лет после посадки.</p>
          <p>Для максимальной урожайности дереву требуется около 10 лет.</p>
          <p>При этом период плодоношения может длиться несколько десятилетий.</p>`,
      },
      {
        type: 'header',
        title: 'От плода до боба',
        text: 'После сбора какао проходит несколько этапов обработки. Именно они формируют будущий вкус шоколада.',
      },
      {
        type: 'section',
        heading: 'Сбор урожая',
        content: `<p>Какао-деревья дают урожай дважды в год.</p>
          <p>Спелые плоды снимают вручную специальными палками с крюком или ножом.</p>
          <p>После этого плоды раскалывают и извлекают какао-бобы.</p>`,
      },
      {
        type: 'section',
        heading: 'Что находится внутри',
        content: `<p>Какао-боб состоит из трёх компонентов: зерна, пульпы и оболочки.</p>
          <p>Примерно 12% составляет оболочка — какао-велла, а 88% — какао-крупка.</p>
          <p>Именно из какао-крупки позже делают шоколад.</p>`,
      },
      { type: 'image', src: 'img4.jpg' },
      {
        type: 'section',
        tip: 'Иногда какао охраняют обычные муравьи',
        heading: 'Муравьи — защитники какао',
        content: `<p>На некоторых плантациях деревья защищают муравьи.</p>
          <p>Они мешают вредителям обосновываться на листьях и плодах, помогая сохранять урожай почти без химии.</p>`,
      },
      {
        type: 'section',
        heading: 'Свежий вкус какао',
        content: `<p>В свежем виде какао-бобы обладают горько-терпким вкусом.</p>
          <p>Чтобы приобрести знакомый шоколадный аромат, они должны пройти несколько этапов обработки.</p>`,
      },
      {
        type: 'header',
        title: 'Под лучами солнца',
        text: 'После сбора какао-бобы ферментируют и сушат. Именно на этом этапе появляется знакомый шоколадный вкус.',
      },
      { type: 'image', src: 'img5.webp' },
      {
        type: 'section',
        heading: 'Ферментация',
        content: `<p>Свежие какао-бобы вместе с мякотью помещают в деревянные ящики на 5–7 дней.</p>
          <p>Во время брожения микроорганизмы преобразуют сахара в спирт, а затем в молочную и уксусную кислоты.</p>
          <p>В результате какао теряет горечь и приобретает шоколадный аромат.</p>`,
      },
      {
        type: 'section',
        heading: 'Как появляется вкус',
        content: `<p>Какао ферментируется благодаря бактериям и грибкам из окружающей среды.</p>
          <p>Из-за этого вкус и аромат шоколада могут сильно отличаться даже у похожих сортов.</p>`,
      },
      {
        type: 'section',
        tip: 'Именно здесь рождается аромат шоколада',
        heading: 'Сушка',
        content: `<p>После ферментации в бобах остаётся много влаги, поэтому их сушат на солнце.</p>
          <p>Бобы раскладывают на циновках и регулярно перемешивают для равномерного высыхания.</p>
          <p>Сушка обычно занимает 1–2 недели.</p>`,
      },
      {
        type: 'section',
        heading: 'Финальный этап',
        content: `<p>После сушки какао-бобы готовы к отправке на фабрику для дальнейшей переработки.</p>
          <p>Дальше из них будут делать какао-масло, какао-массу и шоколад.</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Какао проходит длинный путь прежде, чем превратиться в шоколад.</p>
          <p>Сначала какао-деревья выращивают в жарком и влажном климате, затем собирают плоды и извлекают бобы. После этого какао ферментируют и сушат — именно эти этапы формируют будущий вкус и аромат шоколада.</p>`,
      },
    ]
  },

  buy: {
    title: 'Закупка какао-бобов',
    subtitle: 'Разберёмся, как устроена торговля какао и как Nestlé закупает какао-бобы для своих продуктов.',
    folder: 'article7',
    related: 1,
    blocks: [
      {
        type: 'section',
        summary: true,
        heading: 'Что ты узнаешь:',
        content: `<ul>
            <li>Почему какао-бобы считаются редким продуктом</li>
            <li>Как работают рынки и товарные биржи</li>
            <li>Кто такие трейдеры</li>
            <li>Откуда Nestlé закупает какао</li>
            <li>Как какао попадает на фабрик</li>
          </ul>`,
      },
      {
        type: 'header',
        title: 'Рынки какао',
      },
      {
        type: 'section',
        tip: 'Вот она – точка Х где начинается история шоколада',
        heading: 'Как устроена мировая торговля какао',
        content: `<p>Какао-деревья — очень капризные растения, так как растут далеко не везде. Поэтому какао-бобов в мире не так много, и за ними ведётся настоящая охота. Торговля какао имеет свои особенности: цены постоянно меняются, а покупка сырья происходит через разные механизмы рынка.</p>`,
      },
      {
        type: 'section',
        heading: 'Капризные деревья',
        content: `<p>Какао выращивают только в определённых тропических регионах мира. Для роста деревьям нужны тепло, влажность и стабильный климат, поэтому какао считается редким и ценным продуктом.</p>`,
      },
      { type: 'image', src: 'img1.jpg' },
      {
        type: 'section',
        heading: 'Свободный рынок',
        content: `<p>Покупать какао можно через свободный рынок. Это прямые сделки между компаниями и торговцами-трейдерами, которые собирают какао от фермеров и кооперативов. Здесь каждая сделка индивидуальна.</p>`,
      },
      {
        type: 'section',
        tip: 'Без трейдеров какао бы не путешествовало!',
        heading: 'Кто такие трейдеры',
        content: `<p>Трейдеры помогают какао-бобам попасть от фермеров к производителям шоколада. Они организуют закупки, хранение и поставки сырья.</p>`,
      },
      {
        type: 'section',
        heading: 'Товарные биржи',
        content: `<p>Другой способ торговли — товарные биржи. Это площадки, которые обеспечивают прозрачное ценообразование и помогают покупателям и продавцам согласовывать цены в зависимости от спроса и предложения.</p>`,
      },
      { type: 'image', src: 'img2.jpg' },
      {
        type: 'section',
        heading: 'Почему меняются цены',
        content: `<p>Стоимость какао зависит от&nbsp;ситуации на&nbsp;мировом рынке. Если&nbsp;урожай становится меньше или&nbsp;спрос растёт&nbsp;— цены повышаются. Если&nbsp;какао на&nbsp;рынке больше&nbsp;— стоимость может снижаться.</p>`,
      },
      {
        type: 'header',
        title: 'Как закупает Nestlé',
      },
      {
        type: 'section',
        heading: 'Огромные объёмы какао',
        content: `<p>По данным за 2022 год, Nestlé занимает третье место в мире по закупке какао-бобов. Компания закупает почти полмиллиона тонн какао в год — по весу это можно сравнить примерно с 50 Эйфелевыми башнями.</p>`,
      },
      {
        type: 'section',
        heading: 'Что закупает компания',
        content: `<p>Nestlé закупает какао-бобы для фабрик полного цикла, а также готовые продукты переработки — какао-порошок и другие полуфабрикаты.</p>
          <p>Бобы поставляют трейдеры, а переработанные продукты — компании-производители.</p>`,
      },
      {
        type: 'section',
        heading: 'Главные регионы поставок',
        content: `<p>В основном какао для продуктов Nestlé поставляют из Западной Африки — Ганы и Кот-д’Ивуара.</p>
          <p>Эти страны считаются крупнейшими регионами выращивания какао в мире.</p>`,
      },
      { type: 'image', src: 'img3.jpg' },
      {
        type: 'section',
        tip: 'Вот какой длинный путь у&nbsp;обычной шоколадки!',
        heading: 'От фермы до фабрики',
        content: `<p>Путь какао-боба — настоящее приключение.</p>
          <p>Сначала какао выращивают в тропиках, затем собирают, продают трейдерам, перевозят между странами и отправляют на шоколадные фабрики.</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Какао-деревья растут только в&nbsp;особых климатических условиях. Какао-бобы считаются ценным сырьём. Торговля какао проходит через&nbsp;свободный рынок и&nbsp;товарные биржи. Цены зависят от&nbsp;спроса и&nbsp;предложения. Nestlé входит в&nbsp;число крупнейших покупателей какао в&nbsp;мире. Большая часть какао поступает из&nbsp;Западной Африки.</p>`,
      },
    ]
  },

  materials: {
    title: 'Повторение ключевых материалов',
    subtitle: 'Как напиток древних стал тем, что мы так любим сегодня',
    folder: 'article8',
    related: 1,
    blocks: [
      {
        type: 'section',
        summary: true,
        tip: 'Вспомним всё самое вкусное',
        heading: 'Что ты узнаешь:',
        content: `<ul>
          <li>Как появился шоколад</li>
          <li>Как какао-бобы превращаются в шоколад</li>
          <li>Какие бывают виды шоколада</li>
          <li>Чем отличается молочный, тёмный и белый шоколад</li>
        </ul>`,
      },
      { type: 'image', src: 'img1.webp' },
      {
        type: 'section',
        tip: 'Путь начинается с меня — какао-боба!',
        heading: 'От фермы до фабрики',
        content: `<p>Когда ты возвращаешься к материалу несколько раз, он запоминается намного легче. Советую каждый раз перед началом новой главы коротко освежать в памяти то, что уже изучено.</p>
          <p>Цепочка производства: Какао-бобы → Какао-крупка → Какао тёртое → Какао-масло / Какао-порошок → Шоколадные массы → Готовый шоколад</p>`,
      },
      { type: 'image', src: 'img2.webp' },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img3.webp',
        heading: 'Молочный шоколад',
        content: `<p>Один из самых популярных видов. Молочным его делают молочные ингредиенты, а какао в составе — не менее 25%. Молочный шоколад довольно калорийный из-за высокого содержания сахара.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'left',
        image: 'img4.webp',
        heading: 'Тёмный шоколад',
        content: `<p>Чем выше процент содержания какао, тем темнее и горче шоколад. В горьком шоколаде содержится не менее 55% какао. Он самый полезный: меньше всего сахара и жиров, богат кальцием, железом и магнием.</p>`,
      },
      {
        type: 'sectionImage',
        side: 'right',
        image: 'img5.webp',
        heading: 'Белый шоколад',
        content: `<p>В белом шоколаде нет какао-порошка и твёрдых частиц какао-бобов. Его делают из сахара, молочных компонентов и какао-масла — это и делает его белым, а не коричневым. Много молока и сахара — отсюда яркая сладость.</p>`,
      },
      {
        type: 'section',
        summary: true,
        heading: 'Подведём краткий итог',
        content: `<p>Шоколад прошёл большой путь — от древнего напитка майя до любимого десерта миллионов людей.</p>
          <p>Ты узнал, как какао-бобы превращаются в шоколад, какие этапы проходит производство и чем отличаются разные виды шоколада.</p>
          <p>Теперь ты знаешь о шоколаде гораздо больше — почти как настоящий шоколатье.</p>`,
      },
    ]
  }
};
